import Paper from '@mui/material/Paper'
import React from 'react'
import ThumbsUp from '../../images/ThumbsUp.svg'
import * as S from './styles'
import * as SS from '../../organisms/result/styles.js'
import { SmoothImage} from '../../atoms/SmoothImageLoad'

const whatsappLink = "https://api.whatsapp.com/send?phone=5548998286828&text=Ol%C3%A1!%20Quero%20uma%20vida%20financeira%20tranquila%2C%20quero%20mais%20informa%C3%A7%C3%B5es%20sobre%20o%20Monefica!"

const PositiveDescription = ({ handleClickConversionDialogOpen }) => <Paper style={{
	padding: '20px 16px ',
	margin: 20,
	maxWidth: 900
}}>
	<SS.Row>
		<div style={{height: 40, width: 40}}>
			<SmoothImage src={ThumbsUp} height={40} width={40}/>
		</div>
		<SS.Text style={{ paddingLeft: 12, lineHeight: '1.4em'  }}>
			 No momento, de acordo com os dados informados, você é isento de imposto de renda.
			<br/><br/>
			<strong>Mesmo assim, você gostaria de ter um plano financeiro mais detalhado?</strong>
		</SS.Text>
	</SS.Row>
	<SS.Row>
		<S.CenteredButton onClick={() => {
			window.open(whatsappLink, '_blank');
			if(window.mixpanel){
				window.mixpanel.track("Result description except yes whatapp")
			}
		}} variant="contained" color="primary">SIM! pelo whatsapp!</S.CenteredButton>
	</SS.Row>
</Paper>


export function ExceptDescription({handleClickConversionDialogOpen}) {
	return (<SS.Container>
				<PositiveDescription handleClickConversionDialogOpen={handleClickConversionDialogOpen}/>
	</SS.Container>)
}
